<app-headermain class="visible-lg visible-md"></app-headermain>

<!-- Desktop / tablet: sticky search bar, condensed once the page scrolls -->
<div #resultsSearch class="results-search visible-lg visible-md" [class.results-search--stuck]="isSearchStuck">
  <div class="buupass-container">
    <app-flight-search-bar
      #resultsSearchBar
      variant="results"
      [prefill]="bookingdetails"
      [condensed]="isSearchStuck">
    </app-flight-search-bar>
  </div>
  <app-flight-progress [loading]="isResultsLoading"></app-flight-progress>
</div>

<!-- Mobile: sticky search summary card -->
<div id="tophome" #mobileSearchBar class="hidden-md hidden-lg mobile-search-summary-bar" [class.mobile-search-summary-bar--stuck]="isSearchStuck">
  <button type="button" class="mobile-back-btn" (click)="backHome()" aria-label="Back to home">
    <i class="fas fa-chevron-left" aria-hidden="true"></i>
  </button>
  <button type="button" class="mobile-summary-card" (click)="openModifySearch()" aria-label="Modify search">
    <span class="mobile-summary-card__icon" aria-hidden="true"><i class="fas fa-plane"></i></span>
    <span class="mobile-summary-card__text">
      <span class="mobile-summary-card__route">
        {{fromCityCode}}
        <i class="fas fa-long-arrow-alt-right" aria-hidden="true"></i>
        {{toCityCode}}
      </span>
      <span class="mobile-summary-card__meta">
        {{travelDateInit | date:'d MMM'}}@if (returning && returnDateInit) { &ndash; {{returnDateInit | date:'d MMM'}}}
        &middot; {{totalpassenger || 1}} {{ (totalpassenger || 1) > 1 ? 'travellers' : 'traveller' }}
        &middot; {{ (classType || 'economy') | titlecase }}
      </span>
    </span>
    <span class="mobile-summary-card__edit" aria-hidden="true"><i class="fas fa-pen"></i></span>
  </button>
  <app-flight-progress [loading]="isResultsLoading"></app-flight-progress>
</div>

<!-- Mobile: Modify search sheet -->
<div class="modify-search-overlay" [class.open]="showModifySearch">
  <div class="modify-search-backdrop" (click)="closeModifySearch()"></div>
  <div class="modify-search-panel" role="dialog" aria-modal="true" aria-labelledby="modify-search-title">
    <div class="modify-search-header">
      <h5 id="modify-search-title" class="modify-title">Modify search</h5>
      <button type="button" class="modify-close-btn" (click)="closeModifySearch()" aria-label="Close">
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
    </div>
    <div class="modify-search-body">
      <app-flight-search-bar
        variant="results"
        [prefill]="bookingdetails"
        (submitted)="closeModifySearch()">
      </app-flight-search-bar>
    </div>
  </div>
</div>
<div id="top"></div>
<div class="bus-listing-page  searchFont header-displayed "  #floaded>
  <div class="buupass-container">
    <div class="page-content row ">
      <div class=" u-ib  col-md-12" id="search-results-wrapper">
        <!-- Route header (desktop / tablet; mobile has the summary card) -->
        <div class="visible-lg visible-md">
        <header class="results-header">
          <div class="results-header__route">
            <h1 class="results-header__title">
              <span>{{ bookingdetails?.from_data?.city || dataholderFrom }}</span>
              <span class="results-header__code">{{ fromCityCode }}</span>
              <i class="fas fa-long-arrow-alt-right results-header__arrow" aria-hidden="true"></i>
              <span>{{ bookingdetails?.destination_data?.city || dataholderTo }}</span>
              <span class="results-header__code">{{ toCityCode }}</span>
            </h1>
            <p class="results-header__meta">
              {{ dataholderFrom }} to {{ dataholderTo }}
              &middot; {{ returning ? 'Round trip' : 'One way' }}
              &middot; {{ totalpassenger || 1 }} {{ (totalpassenger || 1) > 1 ? 'travellers' : 'traveller' }}
              &middot; {{ (classType || 'economy') | titlecase }}
            </p>
          </div>
          @if (!isResultsLoading && totalResultCount > 0) {
            <span class="results-header__count">{{ totalResultCount }} {{ totalResultCount === 1 ? 'flight' : 'flights' }} found</span>
          }
        </header>
        </div>

        <div  class="row row-col-static" id="sticky-parent" data-gutter="20">

          <div class="col-md-12 ">
            <!-- Departure-date strip: fares fill in as each date is searched -->
            @if (dateStrip.length) {
              @if (returning && returnDateInit) {
                <div class="date-strip-head">
                  <span class="date-strip-head__label">
                    <i class="fas fa-plane-departure" aria-hidden="true"></i>
                    Choose a departure date
                  </span>
                  <span class="date-strip-head__return">
                    Returning <b>{{ returnDateInit | date:'EEE, d MMM' }}</b>
                    <button type="button" class="date-strip-head__change" (click)="changeReturnDate()">Change</button>
                  </span>
                </div>
              }
              <nav class="date-strip" aria-label="Departure dates">
                <button
                  type="button"
                  class="date-strip__nav"
                  (click)="shiftDateStrip(-1)"
                  [disabled]="!canShiftDateStripBack"
                  aria-label="Earlier dates">
                  <i class="fas fa-chevron-left" aria-hidden="true"></i>
                </button>
                <div class="date-strip__track" #dateStripTrack>
                  @for (day of dateStrip; track trackStripDay($index, day)) {
                    <button
                      type="button"
                      class="date-strip__day"
                      [class.date-strip__day--active]="day.selected"
                      [class.date-strip__day--lowest]="day.lowest"
                      [class.date-strip__day--blocked]="day.afterReturn"
                      [attr.aria-current]="day.selected ? 'date' : null"
                      [attr.title]="day.afterReturn ? 'After your return date. Change the return date first.' : null"
                      [disabled]="day.selected || day.afterReturn || isResultsLoading"
                      (click)="selectStripDate(day)">
                      <span class="date-strip__label">{{ day.date | date:'EEE, d MMM' }}</span>
                      <span class="date-strip__price">
                        @if (day.selected && isResultsLoading) {
                          <span class="date-strip__skeleton" aria-label="Loading fares"></span>
                        } @else if (day.afterReturn) {
                          <span class="date-strip__hint">After return</span>
                        } @else if (day.fare) {
                          {{ day.fare.currency }} {{ day.fare.amount | number:'1.0-0' }}
                        } @else {
                          <span class="date-strip__hint">View fares</span>
                        }
                      </span>
                    </button>
                  }
                </div>
                <button
                  type="button"
                  class="date-strip__nav"
                  (click)="shiftDateStrip(1)"
                  aria-label="Later dates">
                  <i class="fas fa-chevron-right" aria-hidden="true"></i>
                </button>
              </nav>
              @if (stripNotice) {
                <div class="date-strip-notice" role="status">
                  <span class="date-strip-notice__icon" aria-hidden="true"><i class="fas fa-info"></i></span>
                  <span class="date-strip-notice__text">
                    Departure changed to <b>{{ stripNotice.departure | date:'EEE, d MMM' }}</b>.
                    Your return stays <b>{{ stripNotice.returning | date:'EEE, d MMM' }}</b>.
                  </span>
                  <button type="button" class="date-strip-notice__action" (click)="changeReturnDate()">Change return</button>
                  <button type="button" class="date-strip-notice__close" (click)="dismissStripNotice()" aria-label="Dismiss">
                    <i class="fas fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              }
            }
                  @if (isResultsLoading) {
                    <app-results-loader [legs]="returning ? 2 : 1"></app-results-loader>
                  }

                  @if (searchError && !isResultsLoading) {
                    <div class="search-error-state">
                      <div class="search-error-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="12" y1="8" x2="12" y2="12"></line>
                          <line x1="12" y1="16" x2="12.01" y2="16"></line>
                        </svg>
                      </div>
                      <p class="search-error-message">{{ searchError }}</p>
                      <button class="search-error-retry" (click)="onSearch(bookingdetails)">Try Again</button>
                    </div>
                  }

                  @if (totalResultCount < 1 && !isResultsLoading && !searchError) {
                    <app-nobuses [bookingdetails]="bookingdetails"></app-nobuses>
                  }

                  @if (!isResultsLoading) {
                    <div>
                      @if (totalResultCount > 0) {
                        <div class="row results-layout">
                          <div class="col-md-3 _mob-h filters-column">
                            <aside class="filter-panel" aria-label="Filter flights">
                              <div class="filter-panel__header">
                                <h4 class="filter-panel__title">
                                  Filters
                                  @if (activeFilterCount > 0) {
                                    <span class="filter-panel__badge">{{ activeFilterCount }}</span>
                                  }
                                </h4>
                                @if (hasActiveFilters) {
                                  <button type="button" class="filter-panel__reset" (click)="clearFilterSelections()">Reset</button>
                                }
                              </div>

                              <section class="filter-group">
                                <h5 class="filter-group__title">Stops</h5>
                                @for (stops of stopFilterOptions; track stops.value) {
                                  <label
                                    class="filter-row"
                                    [class.filter-row--disabled]="!facetCounts.stops[stops.value] && !selectedStops.includes(stops.value)">
                                    <input
                                      type="checkbox"
                                      class="filter-row__check"
                                      [checked]="selectedStops.includes(stops.value)"
                                      [disabled]="!facetCounts.stops[stops.value] && !selectedStops.includes(stops.value)"
                                      (change)="toggleStopFilter(stops.value)">
                                    <span class="filter-row__label">{{ stops.label }}</span>
                                    <span class="filter-row__count">{{ facetCounts.stops[stops.value] || 0 }}</span>
                                  </label>
                                }
                              </section>

                              <section class="filter-group">
                                <h5 class="filter-group__title">Departure time</h5>
                                <p class="filter-group__hint">From {{ bookingdetails?.from_data?.city || dataholderFrom }} ({{ fromCityCode }})</p>
                                @for (option of timeBucketOptions; track option.value) {
                                  <label
                                    class="filter-row"
                                    [class.filter-row--disabled]="!facetCounts.departure[option.value] && !selectedDepartureBuckets.includes(option.value)">
                                    <input
                                      type="checkbox"
                                      class="filter-row__check"
                                      [checked]="selectedDepartureBuckets.includes(option.value)"
                                      [disabled]="!facetCounts.departure[option.value] && !selectedDepartureBuckets.includes(option.value)"
                                      (change)="toggleDepartureBucket(option.value)">
                                    <span class="filter-row__label">{{ option.label }}</span>
                                    <span class="filter-row__count">{{ facetCounts.departure[option.value] || 0 }}</span>
                                  </label>
                                }
                              </section>

                              <section class="filter-group">
                                <h5 class="filter-group__title">Arrival time</h5>
                                <p class="filter-group__hint">At {{ bookingdetails?.destination_data?.city || dataholderTo }} ({{ toCityCode }})</p>
                                @for (option of timeBucketOptions; track option.value) {
                                  <label
                                    class="filter-row"
                                    [class.filter-row--disabled]="!facetCounts.arrival[option.value] && !selectedArrivalBuckets.includes(option.value)">
                                    <input
                                      type="checkbox"
                                      class="filter-row__check"
                                      [checked]="selectedArrivalBuckets.includes(option.value)"
                                      [disabled]="!facetCounts.arrival[option.value] && !selectedArrivalBuckets.includes(option.value)"
                                      (change)="toggleArrivalBucket(option.value)">
                                    <span class="filter-row__label">{{ option.label }}</span>
                                    <span class="filter-row__count">{{ facetCounts.arrival[option.value] || 0 }}</span>
                                  </label>
                                }
                              </section>

                              @if (airlineFacets.length) {
                                <section class="filter-group">
                                  <h5 class="filter-group__title">Airlines</h5>
                                  <div class="filter-group__list">
                                    @for (airline of airlineFacets; track airline.code) {
                                      <label
                                        class="filter-row"
                                        [class.filter-row--disabled]="!facetCounts.airlines[airline.code] && !selectedAirlines.includes(airline.code)">
                                        <input
                                          type="checkbox"
                                          class="filter-row__check"
                                          [checked]="selectedAirlines.includes(airline.code)"
                                          [disabled]="!facetCounts.airlines[airline.code] && !selectedAirlines.includes(airline.code)"
                                          (change)="toggleAirline(airline.code)">
                                        <img
                                          class="filter-row__logo"
                                          [src]="carrierLogoService.getCarrierLogo(airline)"
                                          [alt]="airline.name"
                                          (error)="carrierLogoService.setLogoPlaceholder($event)">
                                        <span class="filter-row__label">{{ airline.name }}</span>
                                        <span class="filter-row__count">{{ facetCounts.airlines[airline.code] || 0 }}</span>
                                      </label>
                                    }
                                  </div>
                                </section>
                              }

                              <section class="filter-group filter-group--last">
                                <h5 class="filter-group__title">Baggage</h5>
                                <label class="filter-switch" [class.filter-switch--disabled]="!facetCounts.checkedBag && !checkedBagOnly">
                                  <span class="filter-switch__text">
                                    <span class="filter-row__label">Checked bag included</span>
                                    <span class="filter-switch__hint">{{ facetCounts.checkedBag }} {{ facetCounts.checkedBag === 1 ? 'flight' : 'flights' }}</span>
                                  </span>
                                  <input
                                    type="checkbox"
                                    class="filter-switch__input"
                                    role="switch"
                                    [checked]="checkedBagOnly"
                                    [disabled]="!facetCounts.checkedBag && !checkedBagOnly"
                                    (change)="toggleCheckedBag()">
                                  <span class="filter-switch__track" aria-hidden="true"></span>
                                </label>
                              </section>
                            </aside>
                          </div>
                          <div class="col-md-9 col-sm-12 results-column">
                            <div class="results-toolbar _mob-h">
                              <div class="sort-presets" role="group" aria-label="Quick sort">
                                @for (option of quickSortOptions; track option.id) {
                                  <button
                                    type="button"
                                    class="sort-preset"
                                    [class.sort-preset--active]="quickSortPreset === option.id"
                                    [attr.aria-pressed]="quickSortPreset === option.id"
                                    (click)="applyQuickSortPreset(option.id)">
                                    <span class="sort-preset__label">{{ option.label }}</span>
                                    <span class="sort-preset__meta">{{ quickSortMetrics[option.id] || '—' }}</span>
                                  </button>
                                }
                              </div>
                              <div class="results-toolbar__right">
                                <label class="sort-select">
                                  <span class="sort-select__label">Sort by</span>
                                  <span class="sort-select__control">
                                    <select id="desktop-sort-select" [value]="currentSortOption" (change)="onSortChange($event)">
                                      @for (option of secondarySortOptions; track option.value) {
                                        <option [value]="option.value">{{ option.label }}</option>
                                      }
                                    </select>
                                    <i class="fas fa-chevron-down" aria-hidden="true"></i>
                                  </span>
                                </label>
                                <span class="results-toolbar__count">{{ filteredResultCount }} of {{ totalResultCount }} flights</span>
                                @if (hasActiveFilters || currentSortOption !== defaultSortOption) {
                                  <button type="button" class="results-toolbar__reset" (click)="clearAllFilters()">
                                    <i class="fas fa-undo" aria-hidden="true"></i>
                                    Reset
                                  </button>
                                }
                              </div>
                            </div>
                            @if (filteredResultCount === 0) {
                              <div class="filter-results-empty">
                                <span class="filter-results-empty__icon" aria-hidden="true"><i class="fas fa-filter"></i></span>
                                <p class="filter-results-empty__title">No flights match these filters</p>
                                <p class="filter-results-empty__hint">Try removing a filter, or reset to see all {{ totalResultCount }} flights.</p>
                                <button type="button" class="filter-results-empty__btn" (click)="clearFilterSelections()">Reset filters</button>
                              </div>
                            }
                            @if (filteredResultCount > 0) {
                              <div class="scroll-container">
                                @for (result of visibleFlights; track trackByBooking(flightIndex, result); let flightIndex = $index) {
                                  <article
                                    class="fl-card"
                                    [class.fl-card--promo]="result.promo_discount"
                                    [class.fl-card--open]="isFlightDetailExpanded(flightIndex)"
                                    (click)="onCardTap(result, $event)">

                                    @if (result.promo_discount) {
                                      <div class="fl-ribbon">
                                        <i class="fas fa-bolt" aria-hidden="true"></i>
                                        Hot deal &middot; up to {{ getPromoDiscountPercent(result) }}% off
                                      </div>
                                    }

                                    <div class="fl-body">
                                      <!-- Legs -->
                                      <div class="fl-legs">
                                        @for (seg of result.slices; track seg; let si = $index) {
                                          <div class="fl-leg">
                                            <div class="fl-leg__airline">
                                              <img
                                                class="fl-leg__logo"
                                                [src]="carrierLogoService.getCarrierLogo(seg.segments[0].marketing_carrier)"
                                                [alt]="seg.segments[0].marketing_carrier.name || 'Airline logo'"
                                                (error)="carrierLogoService.setLogoPlaceholder($event)">
                                              <div class="fl-leg__airline-text">
                                                @if (result.slices.length > 1) {
                                                  <span class="fl-leg__tag">{{ si === 1 ? 'Return' : 'Onward' }}</span>
                                                }
                                                <span class="fl-leg__name">{{ seg.segments[0].marketing_carrier.name }}</span>
                                                <span class="fl-leg__number">{{ seg.segments[0].marketing_carrier.iata_code }} {{ seg.segments[0].operating_carrier?.flight_number }}</span>
                                              </div>
                                            </div>

                                            <div class="fl-leg__point">
                                              <span class="fl-leg__time">{{ seg.departing_day.split("T")[1] | timeFormart }}</span>
                                              <span class="fl-leg__place"><b>{{ seg.origin.iata_code }}</b> &middot; {{ seg.departing_day.split("T")[0] | date:'EEE, d MMM' }}</span>
                                            </div>

                                            <div class="fl-leg__path">
                                              <span class="fl-leg__duration">{{ seg.duration | duration }}</span>
                                              <span class="fl-leg__line" aria-hidden="true"><i class="fas fa-plane"></i></span>
                                              <span class="fl-leg__stops" [class.fl-leg__stops--direct]="seg.segments.length <= 1">{{ stopLabel(seg) }}</span>
                                            </div>

                                            <div class="fl-leg__point fl-leg__point--arrive">
                                              <span class="fl-leg__time">{{ seg.arriving_day.split("T")[1] | timeFormart }}</span>
                                              <span class="fl-leg__place"><b>{{ seg.destination.iata_code }}</b> &middot; {{ seg.arriving_day.split("T")[0] | date:'EEE, d MMM' }}</span>
                                            </div>
                                          </div>
                                        }
                                      </div>

                                      <!-- Price rail -->
                                      <div class="fl-rail">
                                        <div class="fl-price">
                                          @if (result.promo_discount) {
                                            <span class="fl-price__old">{{ result.total_currency }} {{ result.total_amount | number:'1.0-0' }}</span>
                                          }
                                          <span class="fl-price__now">
                                            @if (result.promo_discount) {
                                              <span class="fl-price__from">From</span>
                                            }
                                            <span class="fl-price__currency">{{ result.total_currency }}</span>
                                            {{ (result.promo_discount ? getPromoFinalAmount(result) : result.total_amount) | number:'1.0-0' }}
                                          </span>
                                          <span class="fl-price__note">
                                            Total for {{ totalpassenger || 1 }} {{ (totalpassenger || 1) > 1 ? 'travellers' : 'traveller' }}
                                          </span>
                                          @if (result.promo_discount) {
                                            <span class="fl-price__save">
                                              Save up to {{ result.promo_discount.user.currency }} {{ result.promo_discount.user.amount | number:'1.0-0' }}
                                            </span>
                                          }
                                        </div>
                                        <button
                                          type="button"
                                          class="fl-book"
                                          [disabled]="loadingCheckFlights"
                                          (click)="$event.stopPropagation(); getFlightDetails(result)">
                                          @if (!loadingCheckFlights) {
                                            <span>Book now</span>
                                            <i class="fas fa-arrow-right" aria-hidden="true"></i>
                                          } @else {
                                            <i class="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
                                            <span>Processing</span>
                                          }
                                        </button>
                                      </div>
                                    </div>

                                    <!-- Footer: what the fare includes + details toggle -->
                                    <div class="fl-foot">
                                      <div class="fl-perks">
                                        <span class="fl-perk">
                                          <i class="fas fa-chair" aria-hidden="true"></i>
                                          {{ (result.available_cabins?.[0]?.cabin || classType || 'Economy') | titlecase }}
                                        </span>
                                        @if (result.available_cabins?.length) {
                                          <span class="fl-perk" [class.fl-perk--off]="!bagSummary(result.available_cabins[0]?.cabin_bag)">
                                            <i class="fas fa-suitcase" aria-hidden="true"></i>
                                            {{ bagSummary(result.available_cabins[0]?.cabin_bag) ? 'Cabin bag ' + bagSummary(result.available_cabins[0]?.cabin_bag) : 'No cabin bag' }}
                                          </span>
                                          <span class="fl-perk" [class.fl-perk--off]="!bagSummary(result.available_cabins[0]?.checked_bag)">
                                            <i class="fas fa-suitcase-rolling" aria-hidden="true"></i>
                                            {{ bagSummary(result.available_cabins[0]?.checked_bag) ? 'Checked bag ' + bagSummary(result.available_cabins[0]?.checked_bag) : 'No checked bag' }}
                                          </span>
                                        }
                                      </div>
                                      <button
                                        type="button"
                                        class="fl-toggle"
                                        [attr.aria-controls]="'searchResultsItem-' + flightIndex"
                                        [attr.aria-expanded]="isFlightDetailExpanded(flightIndex)"
                                        (click)="toggleFlightDetail(flightIndex, $event)">
                                        {{ isFlightDetailExpanded(flightIndex) ? 'Hide details' : 'Flight details' }}
                                        <i class="fas fa-chevron-down" aria-hidden="true"></i>
                                      </button>
                                    </div>

                                    <!-- Expanded details -->
                                    @if (isFlightDetailExpanded(flightIndex)) {
                                      <div class="fl-details" id="searchResultsItem-{{flightIndex}}">
                                        @for (seg of result.slices; track seg; let si = $index) {
                                          <section class="fl-details__slice">
                                            <header class="fl-details__head">
                                              <span class="fl-details__icon" aria-hidden="true">
                                                <i class="fas" [class.fa-plane-departure]="si === 0" [class.fa-plane-arrival]="si !== 0"></i>
                                              </span>
                                              <div>
                                                <h4 class="fl-details__route">
                                                  @if (result.slices.length > 1) {
                                                    <span class="fl-leg__tag">{{ si === 1 ? 'Return' : 'Onward' }}</span>
                                                  }
                                                  {{ seg.origin.city_name || seg.origin.iata_code }}
                                                  <i class="fas fa-long-arrow-alt-right" aria-hidden="true"></i>
                                                  {{ seg.destination.city_name || seg.destination.iata_code }}
                                                </h4>
                                                <p class="fl-details__meta">
                                                  {{ seg.departing_day.split("T")[0] | date:'EEEE, d MMM y' }}
                                                  &middot; {{ stopLabel(seg) }}
                                                  &middot; {{ seg.duration | duration }}
                                                  &middot; {{ (result.available_cabins?.[0]?.cabin || 'Economy') | titlecase }}
                                                </p>
                                              </div>
                                            </header>

                                            <div class="fl-details__grid">
                                              <div class="fl-timeline">
                                                @for (segment of seg.segments; track segment; let sgi = $index) {
                                                  @if (sgi > 0 && seg.segments[sgi - 1]?.waiting != 0) {
                                                    <div class="fl-layover">
                                                      <i class="fas fa-exchange-alt" aria-hidden="true"></i>
                                                      <span>
                                                        Change planes in {{ seg.segments[sgi - 1].destination.city_name }} ({{ seg.segments[sgi - 1].destination.iata_code }})
                                                        &middot; <b>{{ seg.segments[sgi - 1].waiting }}</b> layover
                                                        <a href="https://www.iatatravelcentre.com/passport-visa-health-travel-document-requirements.htm" target="_blank" rel="noopener noreferrer">Check transit visa requirements</a>
                                                      </span>
                                                    </div>
                                                  }
                                                  <div class="fl-segment">
                                                    <div class="fl-segment__carrier">
                                                      <img
                                                        class="fl-segment__logo"
                                                        [src]="carrierLogoService.getCarrierLogo(segment.marketing_carrier)"
                                                        [alt]="segment.marketing_carrier.name || 'Airline logo'"
                                                        (error)="carrierLogoService.setLogoPlaceholder($event)">
                                                      <span class="fl-segment__name">{{ segment.marketing_carrier.name }}</span>
                                                      <span class="fl-segment__number">{{ segment.marketing_carrier.iata_code }} {{ segment.operating_carrier?.flight_number }}</span>
                                                    </div>
                                                    <ol class="fl-stops">
                                                      <li class="fl-stop">
                                                        <span class="fl-stop__time">{{ segment.departing_at.split("T")[1] | timeFormart }}</span>
                                                        <span class="fl-stop__dot" aria-hidden="true"></span>
                                                        <span class="fl-stop__text">
                                                          <b>{{ segment.origin.city_name && segment.origin.city_name !== segment.origin.iata_code ? segment.origin.city_name + ' (' + segment.origin.iata_code + ')' : segment.origin.iata_code }}</b>
                                                          <span>
                                                            {{ segment.departing_at.split("T")[0] | date:'EEE, d MMM' }}
                                                            @if (segment.origin.name && segment.origin.name !== segment.origin.iata_code) {
                                                              &middot; {{ segment.origin.name }}
                                                            }
                                                            @if (segment.origin.terminal) {
                                                              &middot; Terminal {{ segment.origin.terminal }}
                                                            }
                                                          </span>
                                                        </span>
                                                      </li>
                                                      <li class="fl-stop fl-stop--gap">
                                                        <span class="fl-stop__time"></span>
                                                        <span class="fl-stop__dot fl-stop__dot--none" aria-hidden="true"></span>
                                                        <span class="fl-stop__duration"><i class="far fa-clock" aria-hidden="true"></i> {{ segment.duration | duration }}</span>
                                                      </li>
                                                      <li class="fl-stop">
                                                        <span class="fl-stop__time">{{ segment.arriving_at.split("T")[1] | timeFormart }}</span>
                                                        <span class="fl-stop__dot" aria-hidden="true"></span>
                                                        <span class="fl-stop__text">
                                                          <b>{{ segment.destination.city_name && segment.destination.city_name !== segment.destination.iata_code ? segment.destination.city_name + ' (' + segment.destination.iata_code + ')' : segment.destination.iata_code }}</b>
                                                          <span>
                                                            {{ segment.arriving_at.split("T")[0] | date:'EEE, d MMM' }}
                                                            @if (segment.destination.name && segment.destination.name !== segment.destination.iata_code) {
                                                              &middot; {{ segment.destination.name }}
                                                            }
                                                            @if (segment.destination.terminal) {
                                                              &middot; Terminal {{ segment.destination.terminal }}
                                                            }
                                                          </span>
                                                        </span>
                                                      </li>
                                                    </ol>
                                                  </div>
                                                }
                                              </div>

                                              @if (result.available_cabins?.length) {
                                                <aside class="fl-baggage">
                                                  <h5 class="fl-baggage__title">Baggage per adult</h5>
                                                  <div class="fl-baggage__row" [class.fl-baggage__row--off]="!bagSummary(result.available_cabins[0]?.cabin_bag)">
                                                    <span class="fl-baggage__icon" aria-hidden="true"><i class="fas fa-suitcase"></i></span>
                                                    <span class="fl-baggage__text">
                                                      <b>Cabin bag</b>
                                                      <span>{{ bagSummary(result.available_cabins[0]?.cabin_bag) || 'Not included in this fare' }}</span>
                                                    </span>
                                                  </div>
                                                  <div class="fl-baggage__row" [class.fl-baggage__row--off]="!bagSummary(result.available_cabins[0]?.checked_bag)">
                                                    <span class="fl-baggage__icon" aria-hidden="true"><i class="fas fa-suitcase-rolling"></i></span>
                                                    <span class="fl-baggage__text">
                                                      <b>Checked bag</b>
                                                      <span>{{ bagSummary(result.available_cabins[0]?.checked_bag) || 'Not included in this fare' }}</span>
                                                    </span>
                                                  </div>
                                                </aside>
                                              }
                                            </div>
                                          </section>
                                        }
                                      </div>
                                    }
                                  </article>
                                }
                              </div>
                            }
                              </div><!-- end results column -->
                            </div>
                            }<!-- end results-layout -->
                            @if (totalResultCount > 0 && !isMobileSortFilterOpen) {
                              <div class="mobile-filter-bar _desk-h">
                                <button type="button" class="chip" [class.active]="selectedStops.length === 1 && selectedStops[0] === '0'" (click)="toggleNonStopQuickFilter()">Non-stop</button>
                                <button type="button" class="chip" [class.active]="checkedBagOnly" (click)="toggleCheckedBagQuickFilter()">Checked bag</button>
                                <button type="button" class="chip primary" (click)="openMobileSortFilters()">Sort &amp; Filters</button>
                              </div>
                            }
                            <!-- <a class="btn _tt-uc _fs-sm _mt-10 btn-white btn-block btn-lg" href="#">Load More Results</a> -->
                          </div>
                        }

                      </div>
                    </div>


                  </div>
                </div>

              </div>
              @if (isMobileSortFilterOpen) {
                <div class="mobile-sort-filter-overlay _desk-h">
                  <div class="mobile-overlay-backdrop" (click)="closeMobileSortFilters()"></div>
                  <div class="mobile-overlay-panel">
                    <div class="mobile-overlay-header">
                      <button type="button" class="link" (click)="closeMobileSortFilters()">Close</button>
                      <span>Sort &amp; Filters</span>
                      <button type="button" class="link" (click)="clearMobileSelections()">Clear all</button>
                    </div>
                    <div class="mobile-overlay-tabs">
                      <button type="button" [class.active]="mobileSortFilterTab === 'sort'" (click)="mobileSortFilterTab = 'sort'">Sort by</button>
                      <button type="button" [class.active]="mobileSortFilterTab === 'filters'" (click)="mobileSortFilterTab = 'filters'">Filters</button>
                    </div>
                    <div class="mobile-overlay-body">
                      @if (mobileSortFilterTab === 'sort') {
                        <div class="mobile-sort-group">
                          <h5>Price</h5>
                          <label class="filter-option">
                            <input type="radio" name="mobileSortPrice" value="price_asc" [checked]="mobileSelectedSortOption === 'price_asc'" (change)="onMobileSortOptionChange('price_asc')">
                            <span>Cheapest first</span>
                          </label>
                          <label class="filter-option">
                            <input type="radio" name="mobileSortPrice" value="price_desc" [checked]="mobileSelectedSortOption === 'price_desc'" (change)="onMobileSortOptionChange('price_desc')">
                            <span>Costliest first</span>
                          </label>
                        </div>
                        <div class="mobile-sort-group">
                          <h5>Duration</h5>
                          <label class="filter-option">
                            <input type="radio" name="mobileSortDuration" value="duration_asc" [checked]="mobileSelectedSortOption === 'duration_asc'" (change)="onMobileSortOptionChange('duration_asc')">
                            <span>Shortest travel time</span>
                          </label>
                          <label class="filter-option">
                            <input type="radio" name="mobileSortDuration" value="duration_desc" [checked]="mobileSelectedSortOption === 'duration_desc'" (change)="onMobileSortOptionChange('duration_desc')">
                            <span>Longest travel time</span>
                          </label>
                        </div>
                        <div class="mobile-sort-group">
                          <h5>Departure time</h5>
                          <label class="filter-option">
                            <input type="radio" name="mobileSortDeparture" value="dep_time_asc" [checked]="mobileSelectedSortOption === 'dep_time_asc'" (change)="onMobileSortOptionChange('dep_time_asc')">
                            <span>Earliest first</span>
                          </label>
                          <label class="filter-option">
                            <input type="radio" name="mobileSortDeparture" value="dep_time_desc" [checked]="mobileSelectedSortOption === 'dep_time_desc'" (change)="onMobileSortOptionChange('dep_time_desc')">
                            <span>Latest first</span>
                          </label>
                        </div>
                        <div class="mobile-sort-group">
                          <h5>Arrival time</h5>
                          <label class="filter-option">
                            <input type="radio" name="mobileSortArrival" value="arr_time_asc" [checked]="mobileSelectedSortOption === 'arr_time_asc'" (change)="onMobileSortOptionChange('arr_time_asc')">
                            <span>Earliest first</span>
                          </label>
                          <label class="filter-option">
                            <input type="radio" name="mobileSortArrival" value="arr_time_desc" [checked]="mobileSelectedSortOption === 'arr_time_desc'" (change)="onMobileSortOptionChange('arr_time_desc')">
                            <span>Latest first</span>
                          </label>
                        </div>
                      }
                      @if (mobileSortFilterTab === 'filters') {
                        <div class="filter-section">
                          <h5>Stops</h5>
                          @for (option of stopFilterOptions; track option) {
                            <label class="filter-option">
                              <input type="checkbox" [checked]="mobileSelectedStops.includes(option.value)" (change)="toggleMobileSelection('stops', option.value)">
                              <span>{{option.label}}</span>
                            </label>
                          }
                        </div>
                        <div class="filter-section">
                          <h5>Departure from {{dataholderFrom || fromPlaceholder}}</h5>
                          @for (option of timeBucketOptions; track option) {
                            <label class="filter-option">
                              <input type="checkbox" [checked]="mobileSelectedDepartureBuckets.includes(option.value)" (change)="toggleMobileSelection('dep', option.value)">
                              <span>{{option.label}}</span>
                            </label>
                          }
                        </div>
                        <div class="filter-section">
                          <h5>Arrival at {{dataholderTo || toPlaceholder}}</h5>
                          @for (option of timeBucketOptions; track option) {
                            <label class="filter-option">
                              <input type="checkbox" [checked]="mobileSelectedArrivalBuckets.includes(option.value)" (change)="toggleMobileSelection('arr', option.value)">
                              <span>{{option.label}}</span>
                            </label>
                          }
                        </div>
                        @if (airlineFacets.length) {
                          <div class="filter-section">
                            <h5>Airline</h5>
                            <div class="filter-section-list">
                              @for (airline of airlineFacets; track airline) {
                                <label class="filter-option">
                                  <input type="checkbox" [checked]="mobileSelectedAirlines.includes(airline.code)" (change)="toggleMobileSelection('airline', airline.code)">
                                  <span>{{airline.name}} ({{airline.count}})</span>
                                </label>
                              }
                            </div>
                          </div>
                        }
                        <div class="filter-section">
                          <h5>Checked baggage</h5>
                          <label class="filter-option toggle-option">
                            <input type="checkbox" [checked]="mobileCheckedBagOnly" (change)="toggleMobileCheckedBag()">
                            <span>Includes checked baggage</span>
                          </label>
                        </div>
                      }
                    </div>
                    <div class="mobile-overlay-footer">
                      <span class="mobile-result-count">{{mobilePreviewCount}} flights</span>
                      <button type="button" class="btn btn-primary" [disabled]="!hasPendingMobileChanges && mobilePreviewCount === filteredResultCount" (click)="applyMobileSortFilters()">Apply</button>
                    </div>
                  </div>
                </div>
              }
              <div class="theme-page-section margin-grey theme-page-section-white">
                <div class="container">
                  <div class="row row-col-static" id="sticky-parent">

                    <div class="col-md-11">

                      <div class="theme-search-results _mb-10">

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <app-footer></app-footer>
